export default {"src":"/developer/_next/static/media/Sparkle_20.55391e0a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};